//
//
//
//
//
//
//

import { store } from "./store"
import { _slug } from "./helpers"
import { _break_word } from "./helpers"

export default {

  name: 'PanelPresetGroup',
  props: ['preset'],

  computed: {
    txtTypeactiviteit() {
      return _break_word(this.preset._mapping_preset_typeactiviteit)
    },
    iconTypeactiviteit() {
      return 'background-image: url(/app/themes/mapping/dist/images/icons/filters/filter_typeactiviteit_'+ _slug(this.preset._mapping_preset_typeactiviteit) + '.svg'
    },
    iconSector() {
      return 'background-image: url(/app/themes/mapping/dist/images/icons/filters/filter_sector_'+ _slug(this.preset._mapping_preset_sector) + '.svg'
    },
    colorSector() {
      return 'has-color-' + _slug(this.preset._mapping_preset_sector)
    },
  },

  methods: {
    pass_to_filter() {
      let a = [this.preset._mapping_preset_typeactiviteit]
      let s = [this.preset._mapping_preset_sector]
      
      if (a !== undefined && s !== undefined) {
        store.resetFilterValues()
        store.updateFilterValues('typeactiviteit', a)
        store.updateFilterValues('sector', s)
        //send message to update the Map
        this.$root.$emit('updateGoogleMap')
      }
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelPresetGroup.vue